/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Resources/Content/Resources/Loading"
  
}) {
  return (<React.Fragment
>
<span
  data-testid="Loading.Text"
  data-view-path={viewPath}
 className="views-text"
>
Loading...
</span>
{children}
</React.Fragment>)
}